import * as Actions from "../action/inspectionMission";
import {
  FETCH_INSPECTORS_FAILURE,
  FETCH_INSPECTORS_SUCCESS,
  FILTER_INSPECTORS_FAILURE,
  FILTER_INSPECTORS_REQUEST,
  FILTER_INSPECTORS_SUCCESS
} from "../action/inspectionMission";

const initialState = {
  inspectorData: [],
  fetchedInspectors: [],
  filteredInspectors: [],
  loadingInspector: true,
};

const inspectorReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_ALLINSPECTOR: {
      return {
        ...state,
        inspectorData: action.payload,
        loadingInspector: false,
      };
    }
    case FILTER_INSPECTORS_REQUEST:
      return {
        ...state,
        loadingInspector: true,
      };
    case FILTER_INSPECTORS_SUCCESS:
      return {
        ...state,
        loadingInspector: false,
        filteredInspectors: action.payload,
      };
    case FILTER_INSPECTORS_FAILURE:
      return {
        ...state,
        loadingInspector: false,
        error: action.payload,
      };
    case FETCH_INSPECTORS_SUCCESS:
      return {
        ...state,
        fetchedInspectors: action.payload,
        loadingInspector: false,
      };
    case FETCH_INSPECTORS_FAILURE:
      return {
        ...state,
        loadingInspector: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default inspectorReducer;